import React from 'react';
import LeftSidebar from './LeftSidebar';
import TopNavbar from './TopNavbar';
import Footer from './Footer';

interface ProtectedLayoutProps {
  children: React.ReactNode;
  toggleActive: () => void;
  isSidebarActive: boolean;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ 
  children, 
  toggleActive, 
  isSidebarActive 
}) => {

  
  return (
    <>

      <LeftSidebar toggleActive={toggleActive} isSidebarActive={isSidebarActive} />
      <div className="main-content d-flex flex-column">
        <TopNavbar toggleActive={toggleActive} />
        {children}
        <Footer />
      </div>
    </>
  );
};

export default ProtectedLayout;
